import { render, staticRenderFns } from "./HighlightedStatistics.vue?vue&type=template&id=8ed9ffc4&"
import script from "./HighlightedStatistics.vue?vue&type=script&lang=js&"
export * from "./HighlightedStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports